import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { MentorMappingModel } from "./mentor-mapping-model";

export class MentorMappingGridParams extends GridPostParams { }

export class MentorMappingGridModel extends MentorMappingModel { }

export class MentorMappingListingModel extends GridModel<MentorMappingGridModel> { 
    isEmailSendFlag:any='';

}